import { faClose, faDownLeftAndUpRightToCenter, faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";
import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { imageTypesDefinitions } from "../../imports";
import { H2RButton } from "../../imports";
import { ImagePreview } from "../FormElements";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	return (
		<>
			<H2RSelect
				label="Looping"
				selected={cue.loop || "looping"}
				css="mb-2"
				options={[
					{ label: "Loop forever", value: "looping" },
					{ label: "Play once", value: "once" },
					{ label: "Manual", value: "manual" },
				]}
				onChange={(change) => {
					onUpdate({ loop: change });
				}}
			/>
			{cue.loop !== 'manual' &&
				<H2RInput
				placeholder="5"
				value={cue.timePerSection || 5}
				label="Time per image (seconds)"
				type="number"
				min="1"
				max="1000"
				onChange={(change) => {
					if (change < 0) return null;
					return onUpdate({ timePerSection: change });
				}}
			/>}
			{/* <H2RSelect
				label="Section count"
				selected={cue.count || 3}
				css="mb-2"
				options={[
					{ label: "1 section", value: 1 },
					{ label: "2 sections", value: 2 },
					{ label: "3 sections", value: 3 },
				]}
				onChange={(change) => {
					onUpdate({ count: change });
				}}
			/> */}

			<H2RInput
				label={`Background colour`}
				value={cue.bgColour || '#000000'}
				colourPicker={true}
				onChange={(value) => {
					onUpdate({ bgColour: value });
				}}
			/>

			{cue.items.map((t, i) => {
				return (
					<div key={i}>
						<span className="border-b border-gray-700 w-full inline-block bg-gray-400"></span>
						<div className="flex flex-col max-w-sm">
              <div className="mb-2 flex space-x-1 justify-end items-end">
										<H2RSelect
											selected={t.image}
											label={`Image ${i + 1}`}
											options={
												media.length === 0
													? [
															{
																label: "Add images in the Media tab",
																value: ``,
																disabled: true,
															},
													  ]
													: [
															{
																label: "None",
																value: "none",
															},
															...media
																.filter((item) =>
																	imageTypesDefinitions.includes(item?.mimetype)
																)
																.map((item) => {
																	return {
																		label: item.originalname,
																		value: item.filename,
																	};
																}),
													  ]
											}
											onChange={(value) => {
												onUpdate({
													items: [
														...cue.items.map((t, id) => {
															if (id === i) {
																return {
																	...t,
																	image: value,
																};
															} else {
																return t;
															}
														}),
													],
												});
											}}
										/>
										<H2RButton
											text=""
											colour="dark"
											icon={
												t.imageFit === "contain"
													? faUpRightAndDownLeftFromCenter
													: faDownLeftAndUpRightToCenter
											}
											title="Image fit"
											size="small"
											onClick={() => {
												onUpdate({
													items: [
														...cue.items.map((t, id) => {
															if (id === i) {
																return {
																	...t,
																	imageFit:
																		t.imageFit === "contain"
																			? "cover"
																			: "contain",
																};
															} else {
																return t;
															}
														}),
													],
												});
											}}
										/>
										<H2RButton
											text=""
											colour="dark"
											title="Remove image"
											icon={faClose}
											size="small"
											onClick={() => {
                        const updatedArray = Array.from(cue.items)
                        updatedArray.splice(i, 1)
												onUpdate({
													items: updatedArray,
												});
											}}
										/>
							</div>
						<ImagePreview image={t.image} />
						</div>
					</div>
				);
			})}
        <H2RButton
          text="Add another image"
          colour="dark"
          size="small"
          onClick={() => {
            const newItems = Array.from(cue.items)
            newItems.push({url: ''})
            onUpdate({
              items: newItems,
            });
          }}
        />
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
  const lookup = {
    looping: 'Looping',
    once: 'Play once',
		manual : 'Manual'
  }
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">
				{cue.items.length} Image{cue.items.length > 1 ? 's' : ''} • {lookup[cue.loop]}
			</span>
		</div>
	);
};
